// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Lr3fw","title":"style_title__ZY3ye","CTA":"style_CTA__gxDym"};